import { render } from "./draggableCard.vue?vue&type=template&id=1c55cce4"
import script from "./draggableCard.vue?vue&type=script&lang=js"
export * from "./draggableCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__